export enum IntegrationScope {
    INTEGRATION_HOSTED = 'integration_hosted',
    INTEGRATION_EMBEDDED = 'integration_embedded',
    INTEGRATION_SEAMLESS = 'integration_seamless',
    PAY_BY_LINK = 'pay_by_link'
}
